<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AffiliateListItem',
  props: {
    affiliate: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.affiliate);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/affiliate/show/${affiliate.id}`">{{ affiliate.firm }}</router-link>
    </td>
    <td>{{ affiliate.firstname }}</td>
    <td>{{ affiliate.surname }}</td>
    <td>{{ affiliate.zip }}</td>
    <td>{{ affiliate.location }}</td>
    <td>{{ affiliate.street }}</td>
    <td>{{ affiliate.email }}</td>
    <td>{{ affiliate.phone }}</td>
    <td>{{ affiliate.country }}</td>
    <td>{{ affiliate.state }}</td>
    <td width="80" align="right">
      <v-tooltip bottom v-if="auth.hasDeleteRights">
        <v-btn @click.native="onDelete" flat icon slot="activator" :disabled="affiliate.isDelete">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
